import {
  Grid,
  CardHeader,
  CardContent,
  CardActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { formatDistance } from 'date-fns';
import uniqueId from 'lodash.uniqueid';

import {
  ExperienceCardContainer,
  CompanyAvatar,
  CompanyTitle,
  CompanySubtitle,
  VisitSiteButton,
  RoleTitle,
  DetailsList,
  DetailsListItem,
  DetailsText,
  SkillsTitle,
  SkillsImageList,
} from './ProfessionalBackground.styles';
import SkillDisplay from './SkillDisplay';
import LearnMoreAccordion from './LearnMoreAccordion';

function ExperienceCard({ role, isMobile }) {
  const theme = useTheme();
  const large = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <ExperienceCardContainer key={role.role}>
      <CardHeader
        avatar={
          <CompanyAvatar
            logobackgroundcolor={role.logoBackgroundColor}
            aria-label={`${role.company} logo`}
          >
            {role.logo}
          </CompanyAvatar>
        }
        title={<CompanyTitle variant="h3">{role.company}</CompanyTitle>}
        subheader={
          <CompanySubtitle variant="subtitle1">{`${role.location} | ${role.dates} (${formatDistance(new Date(role.startDate), new Date(role.endDate))})`}</CompanySubtitle>
        }
        action={
          <VisitSiteButton
            target="_blank"
            rel="noopener"
            size="small"
            href={role.link}
          >
            VISIT SITE
          </VisitSiteButton>
        }
      />
      <CardContent>
        <Grid container spacing={isMobile ? 1 : 2}>
          <Grid item xs={12} md={8}>
            <RoleTitle variant="h4">{role.role}</RoleTitle>
            <DetailsList>
              {role.details.map(detail => {
                return (
                  <DetailsListItem key={uniqueId(detail)}>
                    <DetailsText variant="body1">{detail}</DetailsText>
                  </DetailsListItem>
                );
              })}
            </DetailsList>
          </Grid>
          <Grid item xs={12} md={4}>
            <SkillsTitle variant="h4">Skills Acquired</SkillsTitle>
            <SkillsImageList
              cols={isMobile ? 1 : large ? 2 : 1}
              variant="masonry"
              component="div"
              role="list"
            >
              {role.skills.map(detail => {
                return (
                  <div key={uniqueId(detail)} role="listitem">
                    <SkillDisplay
                      skillLevel={detail.skillLevel}
                      skillName={detail.skillName}
                    />
                  </div>
                );
              })}
            </SkillsImageList>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions>
        {role.learnMore ? (
          <LearnMoreAccordion
            learnMoreAbout={role.learnMore}
            isMobile={isMobile}
          />
        ) : null}
      </CardActions>
    </ExperienceCardContainer>
  );
}

export default ExperienceCard;
